"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchDocuments = exports.fetchDocument = exports.fetchCoverageForm = void 0;
var types = _interopRequireWildcard(require("./types"));
var _environment = _interopRequireDefault(require("../../environment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* ACTION CREATOR FUNCTIONS
Put here the functions that return an action object that can be dispatched
HINT: Always use functions for consistency, don't export plain objects
*/

var policyUrl = _environment.default.POLICY.policyUrl;
var fetchDocuments = exports.fetchDocuments = function fetchDocuments(policyNumber) {
  var isIdCardPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var url = _url(policyUrl, policyNumber, 'document-list');
  if (isIdCardPage) {
    url += '?isidcard=yes';
  }
  return {
    type: types.LOAD_REQUEST,
    meta: {
      async: true,
      blocking: true,
      method: 'GET',
      url: url
    }
  };
};
var fetchDocument = exports.fetchDocument = function fetchDocument(policyNumber, docId, docQualifier) {
  return {
    type: types.LOAD_ONE_REQUEST,
    meta: {
      async: true,
      blocking: false,
      method: 'GET',
      url: _url(policyUrl, policyNumber, 'document?contentId=' + encodeURIComponent(docId) + '&contentQualifier=' + docQualifier)
    }
  };
};
var fetchCoverageForm = exports.fetchCoverageForm = function fetchCoverageForm(policyNumber, documentLink) {
  return {
    type: types.LOAD_COVERAGE_FORM_REQUEST,
    meta: {
      async: true,
      blocking: false,
      method: 'GET',
      url: _url(policyUrl, policyNumber, 'coverage-form', documentLink)
    }
  };
};
var _url = function _url() {
  for (var _len = arguments.length, fragments = new Array(_len), _key = 0; _key < _len; _key++) {
    fragments[_key] = arguments[_key];
  }
  return fragments.join('/');
};